interface MeterProps {
  /** Percentage, clamped to 0–100; a non-finite value (NaN, missing) shows as 0. */
  value: number;
  /** Accessible name. */
  label: string;
}

/** Thin accent bar + mono percentage. */
export function Meter({ value, label }: MeterProps) {
  const pct = Number.isFinite(value) ? Math.round(Math.min(100, Math.max(0, value))) : 0;
  return (
    <span
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      className="inline-flex items-center gap-2 font-ds"
    >
      <span className="relative h-[5px] w-[54px] overflow-hidden rounded-[3px] bg-ds-sunk">
        <span className="absolute inset-y-0 left-0 rounded-[3px] bg-ds-accent" style={{ width: `${pct}%` }} />
      </span>
      <span className="font-ds-mono text-[12.5px] text-ds-ink2">{pct}%</span>
    </span>
  );
}
